import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalBaseComponent } from '../add-or-edit-org-modal/modal-base.component';
import { ParentSignUpRequest } from '../data/parent-signup-account';
import { NgbModal, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../data/data.service';
import { Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, map, tap } from 'rxjs/operators';
import { VisibleAccount } from '../data/visible-account';
import { NewAccount } from '../data/new-account';
import { Organization } from '../data/organization';
import { Account } from '../data/account';
import { Student } from '../data/student';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-assign-student-to-parent-modal',
  templateUrl: './assign-student-to-parent-modal.component.html',
  styleUrls: ['./assign-student-to-parent-modal.component.css']
})
export class AssignStudentToParentModalComponent extends ModalBaseComponent<Account> implements OnInit {

  constructor(protected modalService: NgbModal,
    protected dataService: DataService, protected route: ActivatedRoute, protected authService: AuthService) {
    super(modalService, dataService)
  }

  sendWelcomeEmail : boolean = true;

  searchAccountResults: VisibleAccount[];
  @Input() student: Student;

  ngOnInit() {
    this.initializeNewData();
  }

  initializeNewData(): void {
    this.data = new Account();
    this.data.Email = '';
    this.data.Name = '';
  };

  existingParentAccount() {
    return this.searchAccountResults != null ? this.searchAccountResults.find(a => a.Email === this.data.Email && a.IsParent) : null;
  }

  existingAccount() {
    return this.searchAccountResults != null ? this.searchAccountResults.find(a => a.Email === this.data.Email) : null;
  }

  createParentAccount() {
    var newAccount = {
      Email: this.data.Email,
      Name: this.data.Name,
      Password: this.data.Password,
      SendWelcomeEmail: this.sendWelcomeEmail,
      RoleCode: "Admin",
      OrganizationRole: "PARENT",
      OrganizationID: this.student.OrganizationID
    };
    this.dataService.createAccount(newAccount).pipe(
      tap(response => {
        this.dataService.addStudentToParent(response.ID, this.student.ID).subscribe(response => this.saveComplete(response));
      })
    ).subscribe();
  }

  searchExistingParents = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      switchMap(term => {
        if (term.length > 2) {
          return this.dataService.searchAccountsByEmail(term).pipe
            (
              tap(items => {
                this.searchAccountResults = items;
              }),
              map(items => items.filter(i => (i.IsVisibileToRequestingAccount && i.IsParent)))

            );
        }
        else {
          return of([]);
        }
      })
    )

  inputFormatter = (selection: VisibleAccount) => this.data.Email;
  resultFormatter = (result: VisibleAccount) => result.Email + ", ID: " + result.AccountID;

  existingParentSelected(event: NgbTypeaheadSelectItemEvent) {
    let selectedParent = event.item;
    this.data.Email = selectedParent.Email;
    this.data.Name = selectedParent.AccountName;
    this.data.ID = selectedParent.AccountID;
    event.preventDefault();
  }

  isInputValid(): boolean {
    return !!(this.existingParentAccount() || 
    (
      this.data.Email
      && this.data.Email.search("@") !== -1
      && this.data.Name
      && this.passwordIsValid()
    ))
  };

  passwordIsValid(): boolean {
    return !!this.data.Password || this.sendWelcomeEmail;
  }

  saveEdit(): void { };
  saveNew(): void {
    var existing = this.existingParentAccount();
    if (existing) {
      console.log("adding existing");
      this.dataService.addStudentToParent(existing.AccountID, this.student.ID).subscribe(response => this.saveComplete(response));
    } else {
      console.log("creating new");
      this.createParentAccount();
    }
  };

  sendWelcomeEmailChanged() {
    this.data.Password = null;
  }
}
